import { render, staticRenderFns } from "./EditEmployee.vue?vue&type=template&id=d997f784&scoped=true&"
var script = {}
import style0 from "./EditEmployee.vue?vue&type=style&index=0&id=d997f784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d997f784",
  null
  
)

export default component.exports